import { FC, memo } from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';
import { useSelector } from 'react-redux';

import MenuItem from './MenuItem';
import { MenuContainer, Popover } from './PopoverMenu.style';

interface IPopoverMenu {
  anchorEl: HTMLElement | null;
  play?: () => void;
  playNext?: () => void;
  addToWaitingList?: () => void;
  setAsLastSong?: () => void;
  removeFromWaitingList?: () => void;
  addAllPlaylistToWaitingList?: () => void;
  handleFavoriteClick?: () => void;
  isFavorite?: boolean;
  closeMenu: () => void;
}

const PopoverMenu: FC<IPopoverMenu> = ({
  anchorEl,
  closeMenu,
  play,
  playNext,
  addToWaitingList,
  setAsLastSong,
  removeFromWaitingList,
  addAllPlaylistToWaitingList,
  handleFavoriteClick,
  isFavorite
}) => {
  const colors = useSelector(colorsSelector);
  const elements = [
    { action: playNext, translation: 'song.play-next' },
    { action: play, translation: 'song.play-now' },
    { action: addToWaitingList, translation: 'song.add-to-waiting-list' },
    { action: setAsLastSong, translation: 'waiting-list.choose-as-last-song' },
    { action: addAllPlaylistToWaitingList, translation: 'playlist.add-all-songs' },
    { action: removeFromWaitingList, translation: 'waiting-list.delete' },
    { action: handleFavoriteClick, translation: isFavorite ? 'song.remove-from-favorites' : 'song.add-to-favorites', withIcon: true },
  ];
  return (
    <Popover
      id={'simple-popover'}
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={() => closeMenu()}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      style={{ borderRadius: '15px' }}
    >
      <MenuContainer {...{ colors }}>
        {elements.map(
          (el) =>
            el.action && (
              <MenuItem key={el.translation} isFavorite={isFavorite} onClick={el.action} translateId={el.translation} withIcon={el.withIcon} />
            ),
        )}
      </MenuContainer>
    </Popover>
  );
};

export default memo(PopoverMenu);
